import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { api } from './api-client';

function replaceVariables(input: string, variables?: { [key: string]: string }): string {
  if (!variables) return input;
  let result = input;

  // Iterate over each key-value pair in the variables object
  for (const [variableName, variableValue] of Object.entries(variables)) {
    const regex = new RegExp(`\\:${variableName}`, 'g');
    result = result.replace(regex, variableValue);
  }

  return result;
}

// https://www.typescriptlang.org/docs/handbook/2/functions.html#function-overloads
export function httpRequest<Request = unknown, Response = unknown>(
  method: 'post' | 'put' | 'patch',
  url: string,
): (data: Request, options?: AxiosRequestConfig) => Promise<AxiosResponse<Response>>;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function httpRequest<_Request = unknown, Response = unknown>(
  method: 'get' | 'delete',
  url: string,
): (options?: AxiosRequestConfig) => Promise<AxiosResponse<Response>>;
export function httpRequest<Request = unknown, Response = unknown>(
  method: 'get' | 'post' | 'put' | 'delete' | 'patch',
  url: string,
) {
  if (method === 'post' || method === 'put' || method === 'patch') {
    // For POST, PUT, PATCH, return a function that accepts data and options
    return (data: Request, options?: AxiosRequestConfig) =>
      api[method]<Response>(replaceVariables(url, options?.urlParams), data, options);
  }
  if (method === 'get' || method === 'delete') {
    // For GET and DELETE, return a function that accepts only options
    return (options?: AxiosRequestConfig) => api[method]<Response>(replaceVariables(url, options?.urlParams), options);
  }

  throw new Error(`Unsupported HTTP method: ${method}`);
}
